<template>
  <ContentLayout>
    <div class="not-found-content">
      Página não encontrada
    </div>
  </ContentLayout>
</template>

<script>
import ContentLayout from "../components/ContentLayout";

export default {
  components: {
    ContentLayout
  }
}
</script>

<style lang="scss" scoped>
.not-found-content {
  text-align: center;
  padding: 20px 0;
}
</style>
